import store from '@/store';

let auth2, loadingPromise;

const createScript = () => {
  return new Promise((resolve) => {
    const el = document.getElementById('auth2_script_id');
    if (!el) {
      let gplatformScript = document.createElement('script')
      gplatformScript.setAttribute('src', 'https://accounts.google.com/gsi/client')
      gplatformScript.setAttribute("async", true)
      gplatformScript.setAttribute("defer", "defer")
      gplatformScript.setAttribute("id", "auth2_script_id")
      document.head.appendChild(gplatformScript);
    }
    resolve();
  });
}
// const createScript_NEW = () => {
//   return new Promise((resolve) => {
//     const el = document.getElementById('auth2_script_id');
//     if (!el) {
//       let gplatformScript = document.createElement('script')
//       gplatformScript.setAttribute('src', 'https://accounts.google.com/gsi/client')
//       gplatformScript.setAttribute("async", true)
//       gplatformScript.setAttribute("defer", "defer")
//       gplatformScript.setAttribute("id", "auth2_script_id")
//       document.head.appendChild(gplatformScript);
//     }
//     resolve();
//   });
// }

const onGapiLoadPromise = () => {
  return new Promise((resolve, reject) => {
    window.onGapiLoad = () => {
      window.gapi.load('auth2', () => {
        try {
          auth2 = window.gapi.auth2.init({
            client_id: store.getters.extensionSettings.auth.google_login.web_client_id
          });
        } catch (err) {
          reject({
            err: 'client_id missing or is incorrect, or if you added extra params maybe they are written incorrectly, did you add it to the component or plugin?'
          })
        }
        resolve(auth2);
      })
    }
  })
}

const loadingAuth2 = () => {
  if (auth2) {
    return Promise.resolve(auth2);
  } else {
    if (!loadingPromise) {
      loadingPromise = onGapiLoadPromise();
    }
    return loadingPromise;
  }
}

const load = () => {
  return Promise.all(
      [loadingAuth2(), createScript()])
    .then((results) => {
      return results[0];
    });
}

const wrapper = (f, method) => {
  if (f) {
    return f[method]();
  } else {
    const err = {
      err: 'Script not loaded correctly, did you add the plugin or the client_id to the component?'
    };
    return Promise.reject(err);
  }
}

const signIn = () => wrapper(auth2, 'signIn');
const signOut = () => wrapper(auth2, 'signOut');
const isSignedIn = () => {
  return auth2 ? auth2.isSignedIn.get() : false;
}

export default {
  load,
  signIn,
  signOut,
  isSignedIn
}
